export enum DashboardRunStatus {
	COMPLETED = 'COMPLETED',
	INTERRUPTED_INTERACTION = 'INTERRUPTED_INTERACTION',
	INTERRUPTED_DEPARTURE = 'INTERRUPTED_DEPARTURE',
	LEAVE = 'LEAVE'
}


